import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import 'index.css';
import App from 'App';
//import App2 from 'App2';
import { LocaleProvider } from 'antd';
import ko_KR from 'antd/lib/locale-provider/ko_KR';
import moment from 'moment';
import 'moment/locale/ko';
import * as serviceWorker from 'serviceWorker';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import ReduxThunk from 'redux-thunk';
import reducers from 'reducers';
import { createBrowserHistory } from 'history';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import ReactGA from 'react-ga';
ReactGA.initialize('UA-147070452-1');

const history = createBrowserHistory();
// Initialize google analytics page view tracking
history.listen(location => {
	ReactGA.set({ page: location.pathname }); // Update the user's current page
	ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

moment.locale('ko');

const render = Component => {
	return ReactDOM.render(Component, document.getElementById('root'));
};

const createStoreWithMiddleware = compose(applyMiddleware(ReduxThunk))(createStore);
const store = createStoreWithMiddleware(reducers);

render(
	<LocaleProvider locale={ko_KR}>
		<Provider store={store}>
			<Router history={history}>
				<Route path="/sentence/:board" component={App} />
			</Router>
		</Provider>
	</LocaleProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

/*
if (module.hot) {
	module.hot.accept('./App', () => {
		const NextApp = require('./App').default;
		render(NextApp);
	});
}
*/
